import React from 'react';
import './levels.css'
import Header from '../components/layout/header';
import pic9 from '../assets/pic9.png'
import pic11 from '../assets/pic11.png'
import Unlockedlevel from '../components/common/unlockedlevel';
import Settings from '../components/common/settings';
import { useState } from 'react';

const Levelspage = () => {
      const [settingsOpen, setSettingsOpen] = useState(false);
    return ( 
        <section className='container-levels-page'>
              {settingsOpen && <Settings onClose={() => setSettingsOpen(false)} />}
            <section className='levels-page-container'>
                <Header onClick={() => setSettingsOpen(true)}
                title='Levels' title2='Levels'
                link='/home'
                
                img={pic9} icontext='Return icon'
                 img2={pic11} icontext2='settings icon'/>

                 <section className='levels-number-container'>
                    <div className='container-level-number-nextt'>
                        <Unlockedlevel numb='1' link='/Story'/>
                    </div>
                 </section>
            </section>
        </section>
     );
}
 
export default Levelspage;